export default [
  ["Elementary Proficiency", "S-1"],
  ["Limited Working Proficiency", "S-2"],
  ["Professional Working Proficiency", "S-3"],
  ["Full Professional Proficiency", "S-4"],
  ["Native or Bilingual Proficiency", "S-5"],
];
